const CallToAction = () => {
  return (
    <section className="call-to-action-section padding-section">
      <h3 className="pt-64-112 call-to-action-section__title text-center">
        Create your event with RegiM
      </h3>
      <div className="call-to-action-section__wrapper-text">
        <p className="mt-16 call-to-action-section__content text-center">
          Leveraging our virtual and live event experience, Hubilo offers
          everything you need to set up your next hybrid event from registration
          to executing a flawless event.
        </p>
      </div>
      <div className="call-to-action-section__action pb-64-112">
        <button className="button button__lg mt-40 ">Get Early Access</button>
      </div>
    </section>
  );
};

export default CallToAction;
